// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pvho","content":"styles_content__2WjuL","row":"styles_row__oJKdh","footer":"styles_footer__2wTDM","phraseLength":"styles_phraseLength__Y6__V"};